<template>
  <div class="em-block form-style">
    <div class="em-child">
      <h3>{{folder.name}}</h3>

      <template v-if="isEditing">
        <label for="link-name">Link Name</label>
        <input v-model="link.name" type="text" id="link-name">
      </template>

      <template v-else>
        <h4>Link Name</h4>
        <p>{{link.name}}</p>
      </template>

      <h5>Link to...</h5>
      <div class="em-child">

        <row v-if="showBackButton">
          <column>
            <button @click="resetUi" class="btn-link"><span class="icon arrow-chevron left"></span> Go back</button>
          </column>
        </row>

        <row class="quickmenu-links">
          <template v-for="configRow in selectedBuilderConfigsWithLevelInRows">
            <bookmark-link-builder-node
              v-for="({config, level}, index) in configRow"
              :key="`${level}-${index}`"
              :builder-config="config"
              :level="level"
              :isEditing="isEditing"
              @showBackButton="showBackButton = true"
            ></bookmark-link-builder-node>
          </template>
        </row>
      </div>

      <div class="cta">
        <template v-if="isEditing">
          <button @click="cancelClicked" type="button" class="btn red outline block">Cancel</button>
          <button @click="saveClicked" type="button" class="btn green block" :disabled="!saveEnabled">Save</button>
        </template>
        <template v-else>
          <button @click="editClicked" type="button" class="btn grey-to-blue block">
            <span class="icon pencil"></span>
            Edit
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import * as _ from 'lodash';
  import BookmarkFolder from "../../models/bookmarkFolder";
  import BookmarkLink from "../../models/bookmarkLink";
  import BookmarkLinkBuilderNode from './bookmark-link-builder-node.vue';
  import BookmarkMenuStoreMixinFactory from '../../mixins/bookmarkMenuStoreMixinFactory';
  import ConfigureSidebarInterfaceStoreMixin from "../../mixins/configureSidebarInterfaceStoreMixin";
  import {ConfigureSidebarModes} from "../../enums/configureSidebarModes";

  const bookmarkMenuStoreMixin = BookmarkMenuStoreMixinFactory({
    state: ['bookmarkMenu'],
    actions: [
      'createBookmarkLink',
      'updateBookmarkLink',
    ],
  });

  export default Vue.extend({
    mixins: [
      bookmarkMenuStoreMixin,
      ConfigureSidebarInterfaceStoreMixin
    ],
    components: {BookmarkLinkBuilderNode},
    props: {
      folder: {
        type: BookmarkFolder,
      },
      existingLink: {
        type: BookmarkLink,
      },
    },
    data: function(): object {
      return {
        link: {
          type: BookmarkLink
        },
        showBackButton: {
          type: Boolean,
          default: false
        },
        ConfigureSidebarModes
      }
    },
    created() {
      this.resetUi();
    },
    watch: {
      folder() {
        this.resetUi();
      },
      existingLink() {
        this.resetUi();
      },
    },
    computed: {
      isEditing() { // TODO: think of name
        const mode = this.interfaceMode;
        return (mode === ConfigureSidebarModes.editLink) || (mode === ConfigureSidebarModes.newLink);
      },
      // TODO: think of better names
      builderLinkPartialJson() {
        return this.$store.getters['bookmarkLinkBuilderInterfaceStore/linkPartialJson'];
      },
      saveEnabled(): boolean {
        const partialLink = this.builderLinkPartialJson;

        return this.link.name.length > 0 && (partialLink.url || partialLink.route);
      },
      selectedBuilderConfigs() {
        return this.$store.state.bookmarkLinkBuilderInterfaceStore.selectedConfigs;
      },
      selectedBuilderConfigsWithLevelInRows() {
        const configsWithLevel = _.map(this.selectedBuilderConfigs, function (config, index) {
          return {
            config,
            level: index
          };
        });

        return _.chunk(configsWithLevel, 3);
      },
    },
    methods: {
      cancelClicked() {
        if (this.existingLink) {
          this.setInterfaceMode({mode: ConfigureSidebarModes.showLink, selected: this.existingLink});
          this.resetUi();
        } else {
          this.setInterfaceMode({mode: ConfigureSidebarModes.showFolder, selected: this.folder});
        }
      },
      editClicked() {
        this.setInterfaceMode({mode: ConfigureSidebarModes.editLink, selected: this.existingLink});
        this.resetUi();
      },
      saveClicked(): void {
        if (this.builderLinkPartialJson.url) {
          this.$store.commit('bookmarkLinkBuilderInterfaceStore/validateTextInput');

          if (this.$store.state.bookmarkLinkBuilderInterfaceStore.textInputInvalid) {
            return;
          }
        }

        this.link.loadFromJson(this.builderLinkPartialJson);

        let promiseResult = null;
        if (this.existingLink) {
          this.existingLink.loadFromJson(this.link.asJsonForLoad());
          promiseResult = this.updateBookmarkLink({bookmarkLink: this.existingLink});
        } else {
          promiseResult = this.createBookmarkLink({bookmarkLink: this.link});
        }

        promiseResult.then((bookmarkLink) => {
          this.setInterfaceMode({mode: ConfigureSidebarModes.showLink, selected: bookmarkLink});
        });
      },
      resetUi() {
        if (this.existingLink) {
          this.link = new BookmarkLink().loadFromJson(this.existingLink.asJsonForLoad());

          this.$store.commit('bookmarkLinkBuilderInterfaceStore/setStateFromLink',
            {link: this.link, isEditing: this.isEditing});
        } else {
          this.link = new BookmarkLink().loadFromJson({
            bookmark_folder_id: this.folder.id,
          });

          this.$store.commit('bookmarkLinkBuilderInterfaceStore/clearState');
        }
        this.showBackButton = false;
      },
    },
  })
</script>
